export default {
  data() {
    return {
      sidePanelOpen: true
    }
  },
  methods: {
    /*
     * Modifica el valor de sidePanelOpen que envía el evento emitido por el componente sidepanel
     */
    changeOpen(newOpen) {
      this.sidePanelOpen = newOpen
    }
  }
}
